<template>
  <div class="h-full grid grid-rows-[auto_auto_1fr] text-[#ABABAB]">
    <ThreadsNav :show-center="false" class="w-full" show-back />

    <VanTabs v-model:active="store.role.tabType">
      <VanTab :title="t(`story.role.my`)"></VanTab>
      <VanTab :title="t(`story.role.admiring`)"></VanTab>
      <VanTab :title="t(`story.role.admire`)"></VanTab>
    </VanTabs>

    <div class="overflow-auto">
      <div
        v-for="item in store.canSelectStoreMateList"
        class="flex gap-4 my-3 px-3"
      >
        <div class="flex flex-col items-center">
          <UserAvatar
            :avatar-url="item.mediaUrl"
            class="w-[100px] aspect-[3/4] mb-4"
          />
        </div>
        <div class="flex-1 flex flex-col">
          <div class="flex justify-between items-center mb-2">
            <div class="flex">
              <p class="mr-2">{{ item.name }}</p>
              <i
                :class="[
                  'iconfont',
                  item.gender === 1 && 'icon-male text-[#5D9CEC]',
                  item.gender === 2 && 'icon-female text-[#EC4899]',
                ]"
              />
            </div>
            <button class="btn btn-xs px-6" @click="clickSelect(item.id)">
              {{ t(`story.role.select`) }}
            </button>
          </div>
          <p class="text-xs">
            {{ item.bio }}
          </p>
        </div>
      </div>
      <div v-if="store.canSelectStoreMateList.length === 0">
        <VanEmpty :description="$t('Message.noCharactersAvailable')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAdmire } from "@/stores/admire";
import { useStoryBook } from "@/stores/story-book";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const { t } = useI18n();
const store = useStoryBook();
const admireStore = useAdmire();
const router = useRouter();
const clickSelect = (id: number) => {
  store.form.characterzz!.push({
    mateId: id,
    role: 1,
  });
  router.back();
};

onMounted(() => {
  admireStore.getAdmirerList();
  admireStore.getAdmiringList();
});
</script>
